module.exports = __webpack_public_path__ + "media/images/heart-fail-30a3e9b2b644bc388f17d430d35bd5e2.svg";